import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import { Layout } from '@/components/Layout';
import { getAuthStore, useAuthStore } from '@/stores/authStore';
import { getCurrentUser } from '@/lib/api/client';
import { isServer } from '@/config';

import { Home } from '@/pages/Home';
import { Login } from '@/pages/Login';
import { Register } from '@/pages/Register';
import { MyMachines } from '@/pages/MyMachines';
import { MachineProfile } from '@/pages/MachineProfile';
import { MachineEdit } from '@/pages/MachineEdit';
import { Billing } from '@/pages/Billing';
import { MyProfile } from '@/pages/MyProfile';
import { ShareJoin } from '@/pages/ShareJoin';
import { UserProfile } from '@/pages/UserProfile';
import { XpraClient } from '@/pages/XpraClient';
import { NotFound } from '@/pages/NotFound';

/** Fetch the current user once on mount to populate the auth store. */
function SessionBootstrap(): null {
  const hasChecked = useAuthStore((s) => s.hasCheckedSession);
  useEffect(() => {
    if (isServer || hasChecked) return;
    const store = getAuthStore();
    getCurrentUser()
      .then((user) => store.getState().setUser(user))
      .catch(() => store.getState().setUser(null));
  }, [hasChecked]);
  return null;
}

export default function App(): React.ReactElement {
  return (
    <>
      <SessionBootstrap />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/account" element={<MyProfile />} />
          <Route path="/account/billing" element={<Billing />} />
          <Route path="/machines/mine" element={<MyMachines />} />
          <Route path="/m/:publicId" element={<MachineProfile />} />
          <Route path="/m/:publicId/edit" element={<MachineEdit />} />
          <Route path="/m/:publicId/share/:code" element={<ShareJoin />} />
          <Route path="/xpra" element={<XpraClient />} />
          <Route path="/xpra/:nonce" element={<XpraClient />} />
          <Route path="/:username" element={<UserProfile />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </>
  );
}
